import axios from 'axios';

export const qrBatchApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/qr-batch`,
    headers: {
        'Content-Type': 'application/json'
    }
})